// import PropTypes from 'prop-types';
// // material
// import { alpha, styled } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// const RootStyle = styled('span')(({ theme, ownerState }) => {
//   const isLight = theme.palette.mode === 'light';
//   const { color, variant } = ownerState;

//   const styleFilled = (color) => ({
//     color: theme.palette[color].contrastText,
//     backgroundColor: theme.palette[color].main
//   });

//   const styleOutlined = (color) => ({
//     color: theme.palette[color].main,
//     backgroundColor: 'transparent',
//     border: `1px solid ${theme.palette[color].main}`
//   });

//   const styleGhost = (color) => ({
//     color: theme.palette[color][isLight ? 'dark' : 'light'],
//     backgroundColor: alpha(theme.palette[color].main, 0.16)
//   });

//   return {
//     height: 22,
//     minWidth: 22,
//     lineHeight: 0,
//     borderRadius: 8,
//     cursor: 'default',
//     alignItems: 'center',
//     whiteSpace: 'nowrap',
//     display: 'inline-flex',
//     justifyContent: 'center',
//     padding: theme.spacing(0, 1),
//     color: theme.palette.grey[800],
//     fontSize: theme.typography.pxToRem(12),
//     fontFamily: theme.typography.fontFamily,
//     backgroundColor: theme.palette.grey[300],
//     fontWeight: theme.typography.fontWeightBold,

//     ...(color !== 'default'
//       ? {
//           ...(variant === 'filled' && { ...styleFilled(color) }),
//           ...(variant === 'outlined' && { ...styleOutlined(color) }),
//           ...(variant === 'ghost' && { ...styleGhost(color) })
//         }
//       : {
//           ...(variant === 'outlined' && {
//             backgroundColor: 'transparent',
//             color: theme.palette.text.primary,
//             border: `1px solid ${theme.palette.grey[500_32]}`
//           }),
//           ...(variant === 'ghost' && {
//             color: isLight ? theme.palette.text.secondary : theme.palette.common.white,
//             backgroundColor: theme.palette.grey[500_16]
//           })
//         })
//   };
// });

// // ----------------------------------------------------------------------

// export default function Label({ color = 'default', variant = 'ghost', children, ...other }) {
//   return (
//     <RootStyle ownerState={{ color, variant }} {...other}>
//       {children}
//     </RootStyle>
//   );
// }

// Label.propTypes = {
//   children: PropTypes.node,
//   color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error', 'teal', 'orangy', 'indigo']),
//   variant: PropTypes.oneOf(['filled', 'outlined', 'ghost'])
// };
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { alpha, styled, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
//

export const StyledLabel = styled(Box)(({ theme, ownerState }) => {
  const isLight = theme.palette.mode === 'light';

  const filledVariant = ownerState.variant === 'filled';

  const outlinedVariant = ownerState.variant === 'outlined';

  const softVariant = ownerState.variant === 'soft';

  const defaultStyle = {
    ...(ownerState.color === 'default' && {
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
      }),
      // SOFT
      ...(softVariant && {
        color: isLight ? theme.palette.text.primary : theme.palette.common.white,
        backgroundColor: alpha(theme.palette.grey[500], 0.16),
      }),
    }),
  };

const isPaletteColor = theme.palette[ownerState.color] !== undefined;
  // const colorStyle = {
  //   ...(ownerState.color !== 'default' && {
  //     // FILLED
  //     ...(filledVariant && {
  //       color: theme.palette[ownerState.color].contrastText,
  //       backgroundColor: theme.palette[ownerState.color].main,
  //     }),
  //     // OUTLINED
  //     ...(outlinedVariant && {
  //       backgroundColor: 'transparent',
  //       color: theme.palette[ownerState.color].main,
  //       border: `1px solid ${theme.palette[ownerState.color].main}`,
  //     }),
  //     // SOFT
  //     ...(softVariant && {
  //       color: theme.palette[ownerState.color][isLight ? 'dark' : 'light'],
  //       backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
  //     }),
  //   }),
  // };
  const colorValue = ownerState.color;
  const colorStyle = {
    ...(colorValue !== 'default' && {
      ...(filledVariant && {
        color: isPaletteColor
          ? theme.palette[colorValue].contrastText
          : '#fff', // fallback contrast text for hex colors
        backgroundColor: isPaletteColor
          ? theme.palette[colorValue].main
          : colorValue, // use the hex directly
      }),
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        color: isPaletteColor
          ? theme.palette[colorValue].main
          : colorValue,
        border: `1px solid ${
          isPaletteColor ? theme.palette[colorValue].main : colorValue
        }`,
      }),
      ...(softVariant && {
        color: isPaletteColor
          ? theme.palette[colorValue][isLight ? 'dark' : 'light']
          : colorValue,
        backgroundColor: isPaletteColor
          ? alpha(theme.palette[colorValue].main, 0.16)
          : alpha(colorValue, 0.16),
        }),
      }),
    };

  return {
    height: 24,
    minWidth: 22,
    lineHeight: 0,
    borderRadius: 6,
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    // textTransform: 'capitalize',
    padding: theme.spacing(0, 1),
    color: theme.palette.grey[800],
    fontSize: theme.typography.pxToRem(12),
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.grey[300],
    fontWeight: theme.typography.fontWeightBold,
    ...colorStyle,
    ...defaultStyle,
  };
});

// ----------------------------------------------------------------------

const Label = forwardRef(
  ({ children, color = 'default', variant = 'soft', startIcon, endIcon, sx, ...other }, ref) => {
    const theme = useTheme();

    const iconStyle = {
      width: 16,
      height: 16,
      '& svg, img': { width: 1, height: 1, objectFit: 'cover' },
    };

    return (
      <StyledLabel
        ref={ref}
        component="span"
        ownerState={{ color, variant }}
        sx={{
          ...(startIcon && { pl: 0.75 }),
          ...(endIcon && { pr: 0.75 }),
          ...sx,
        }}
        theme={theme}
        {...other}
      >
        {startIcon && <Box sx={{ mr: 0.75, ...iconStyle }}> {startIcon} </Box>}

        {children}

        {endIcon && <Box sx={{ ml: 0.75, ...iconStyle }}> {endIcon} </Box>}
      </StyledLabel>
    );
  }
);

Label.propTypes = {
  sx: PropTypes.object,
  endIcon: PropTypes.node,
  children: PropTypes.node,
  startIcon: PropTypes.node,
  variant: PropTypes.oneOf(['filled', 'outlined', 'ghost', 'soft']),
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
  ]),
};

export default Label;
